import React from "react";
import { Space, Table } from "antd";
import ActionCell from "../helpers/ActionCell";


const DynamicColumnsTable = props => {
  const { columns, height, rowKey, source, width ,actions,workflow,rows} = props;

 

  let columnsWithaction = columns;
        let obj = {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
              <Space size="middle">
                {actions && actions.map((action,index)=>{
                     return      <a>Edit {index}</a>
                // <a>Delete</a>
                    //  <ActionCell
                    //  actions={actions}
                    //  rows={rows}
                    //  workflow={workflow}
                    //  template2Table={true}
                    //  />
                })}
                {/* <a>Edit {record.name}</a>
                <a>Delete</a> */}
              </Space>
            ),
            fixed: "right",
            width:200
          }

          columnsWithaction.push(obj);

  return (
    <Table
      columns={columnsWithaction}
      dataSource={source}
      rowKey={rowKey}
      scroll={{ x: width, y: height }}
    />
  );
};

export default DynamicColumnsTable;
